import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { LocalDataService } from "../../../../../../modules/shared/services/local-data.service";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "html-config",
    templateUrl: "./html-config.view.html",
    providers: []
})
export class HtmlConfigView implements OnInit {
    ddfs: Array<any>;
    ddfData: Array<any> = [];
    ddfGroups: Array<string> = [];
    baseUrl = "";
    textConfig: any = {};
    ddfJson = "session-ddf.json";

    constructor(
        public sharedService: SharedService,
        private localDataService: LocalDataService,
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit() {
        this.baseUrl = this.sharedService.sessionUrl;
        if (this.activatedRoute.parent.routeConfig.path == "speaker-sessions") {
            this.ddfGroups = ["Session"];

            this.textConfig = this.sharedService.sessionLayoutConfig.catalogConfig[
                this.sharedService.expansionStyle
            ].textConfig;

            this.localDataService.getJSON(this.ddfJson).subscribe((data) => {
                if (data != null) {
                    this.ddfData = data;
                    if (
                        this.sharedService.sessionCustomFields != null &&
                        this.sharedService.sessionCustomFields.length > 0
                    ) {
                        this.ddfGroups.push("Session custom field");
                        this.sharedService.sessionCustomFields.forEach((cf) => {
                            if (this.baseUrl == "mysession") {
                                if (cf.questionTypeId != 19) {
                                    this.ddfData.push({
                                        label: cf.name,
                                        key: "{@ddf.customFieldMap." + cf.code.replace(/ /g, "") + "@}",
                                        type: "Session custom field"
                                    });
                                }
                            } else {
                                this.ddfData.push({
                                    label: cf.name,
                                    key: "{@ddf.customFieldMap." + cf.code.replace(/ /g, "") + "@}",
                                    type: "Session custom field"
                                });
                            }
                        });
                    }

                    this.fetchDdfs();
                }
            });
        } else if (this.activatedRoute.parent.routeConfig.path == "speaker") {
            this.ddfGroups = ["Speaker"];
            this.textConfig = this.sharedService.speakerLayoutConfig[this.baseUrl].catalogConfig[
                this.sharedService.expansionStyle
            ].textConfig;
            this.localDataService.getJSON("speaker-ddf.json").subscribe((data) => {
                if (data != null) {
                    this.ddfData = data;
                    if (
                        this.sharedService.speakerCustomFields != null &&
                        this.sharedService.speakerCustomFields.length > 0
                    ) {
                        this.ddfGroups.push("Speaker custom field");
                        this.sharedService.speakerCustomFields.forEach((cf) => {
                            this.ddfData.push({
                                label: cf.name,
                                key: "{@ddf.customFieldMap." + cf.code.replace(/ /g, "") + "@}",
                                type: "Speaker custom field"
                            });
                        });
                    }

                    this.fetchDdfs();
                }
            });
        }
    }

    setHeader(ev) {
        this.textConfig.template = ev;
    }

    fetchDdfs() {
        let ddfResults = [];
        for (let i = 0; i < this.ddfData.length; i++) {
            const ddf = this.ddfData[i];

            let groupName = ddf.type.toLowerCase();
            groupName = groupName.charAt(0).toUpperCase() + groupName.substring(1);
            const tinymceDdf = {
                group: groupName,
                title: ddf.label.trim(),
                variableKey: ddf.key.substring(2, ddf.key.length - 2),
                variableValue: ddf.label.trim()
            };
            ddfResults.push(tinymceDdf);
        }
        this.ddfs = ddfResults;
    }
}
